export default __webpack_public_path__ + "eed5bd8897325905ca4f4b87497d6a19.svg";